import { render, staticRenderFns } from "./LandLineAlert.vue?vue&type=template&id=2f3497cd&scoped=true"
import script from "./LandLineAlert.vue?vue&type=script&lang=js"
export * from "./LandLineAlert.vue?vue&type=script&lang=js"
import style0 from "./LandLineAlert.vue?vue&type=style&index=0&id=2f3497cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3497cd",
  null
  
)

export default component.exports